// extracted by mini-css-extract-plugin
export default {"title":"NoCreditsModal_title__oSHPi"};